<template>
	<div
		v-if="stat.views || (block.type !== 'facebook' && categories.length)"
		class="c-block-view-labels"
	>
		<!-- <label
			v-if="showAdSpend"
			v-tooltip="tooltip(`Estimated Ad Spend(In EU only)`)"
		>
			<svg
				width="20"
				height="20"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M12 7.5V6.5M12 16.5V17.5M14.1655 9C13.7333 8.4022 12.9254 8 12 8H11.7222C10.4949 8 9.5 8.79594 9.5 9.77778V9.8541C9.5 10.5564 9.99598 11.1984 10.7812 11.5125L13.2188 12.4875C14.004 12.8016 14.5 13.4436 14.5 14.1459C14.5 15.1699 13.4624 16 12.1824 16H12C11.0746 16 10.2667 15.5978 9.83446 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
			<p>${{ format(adSpend) }} Est EU Ad spend</p>
		</label> -->
		<!-- <label
			v-if="showAdReach"
			v-tooltip="tooltip(`Estimated Ad Reach(In EU only)`)"
		>
			<svg
				width="20"
				height="20"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M16 7H21V12M20.5 7.5L13 15L9 11L3 17"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
			<p>{{ format(adReach) }} Est EU reach</p>
		</label> -->
		<label v-if="stat.views" v-tooltip="tooltip(`How many views this Ad got`)">
			<svg
				width="20"
				height="20"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M9 5L9 19M3.00439 11L3 19M21 8L21 19M14.9978 14L14.9978 19"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
			<p>
				{{ format(stat.views) }}
			</p>
		</label>
		<label
			v-if="block.type !== 'facebook' && categories && categories.length > 0"
			v-tooltip="tooltip(`What is this Ad's primary asset format`)"
		>
			<svg
				width="20"
				height="20"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3M16.7712 13.2709C16.1341 15.2995 14.2389 16.7711 12 16.7711C9.23858 16.7711 7 14.5325 7 11.7711C7 9.53228 8.47145 7.63713 10.5 7M14 10H18L21.5 6.5L18.5 5.5L17.5 2.5L14 6V10ZM14 10L12 12"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
			<p>
				{{ categories[0] }}
			</p>
		</label>
	</div>
</template>

<script>
import stats from '@swipekit/lib/stats';

export default {
	props: {
		block: {},
	},

	computed: {
		categories: function () {
			let categories = [];

			categories = this.block.categories || [];

			categories = categories.map((cat) => {
				if (typeof cat !== 'string') {
					return cat.text || '';
				}
				return cat;
			});

			return categories;
		},
		stat: function () {
			let block = this.block;
			let s = stats(block);

			return s;
		},
		showAdSpend: function () {
			if (this.block.type === 'facebook' && this.block.meta.isEuAd) {
				return true;
			}

			return false;
		},
		showAdReach: function () {
			if (this.block.type === 'facebook' && this.block.meta.isEuAd) {
				return true;
			}

			return false;
		},
		showAssetType: function () {
			return true;
		},

		adSpend: function () {
			let spend = Math.round(this.block.meta.eu_ad_spend);

			if (spend === 0) {
				spend = 1;
			}

			if (isNaN(spend)) {
				return 'N/A';
			}

			spend = spend.toLocaleString('en-US');

			return spend;
		},
		adReach: function () {
			let reach = this.block.meta.eu_total_reach;

			if (isNaN(reach)) {
				return 'N/A';
			}

			reach = reach.toLocaleString('en-US');

			return reach;
		},
	},

	methods: {
		tooltip: function (content) {
			return { content: content, offset: 4, delay: 0 };
		},
		format: function (num) {
			let newNum = parseInt(num);
			if (isNaN(newNum)) {
				return num;
			}

			return num.toLocaleString('en-US');
		},
	},
};
</script>

<style lang="scss">
.c-block-view-labels {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: var(--spacer-sm);

	label {
		display: flex;
		align-items: center;
		padding: 0.25rem;
		//border: var(--color-bg-4) solid 1px;
		border-radius: 0.25rem;
		margin-right: var(--margin);
		border: var(--color-bg-4) solid 1px;
		background-color: var(--color-bg-2);
		font-weight: 500;
		font-size: var(--font-size-xs);
		font-feature-settings: 'case' 0, 'dlig' 0, 'frac' 0, 'dnom' 0, 'numr' 0,
			'subs' 0, 'sups' 0, 'tnum', 'zero' 0, 'ss01', 'ss02' 0, 'ss03' 0, 'ss04',
			'ss05' 0, 'ss06' 0, 'ss07' 0, 'ss08' 0, 'cv01' 0, 'cv02' 0, 'cv03' 0,
			'cv04' 0, 'cv05' 0, 'cv06' 0, 'cv07' 0, 'cv08' 0, 'cv09' 0, 'cv10' 0,
			'cv11' 0, 'cv12' 0, 'cv13' 0, 'cpsp' 0, 'c2sc' 0, 'salt' 0, 'aalt' 0,
			'calt', 'ccmp', 'locl', 'kern';

		> svg {
			margin-left: 2px;
			margin-right: var(--margin);
			opacity: 0.65;
		}

		> p {
			line-height: 19px;
			margin-bottom: 0;
			margin-right: 2px;
			opacity: 0.85;
		}
	}
}
</style>
